var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeriodicity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2549_9056",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2549_9056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 17.5C3.96667 17.5 2.66667 16.9667 1.6 15.9C0.533333 14.8333 0 13.5333 0 12C0 10.4667 0.533333 9.16667 1.6 8.1C2.66667 7.03333 3.96667 6.5 5.5 6.5C6.11667 6.5 6.70833 6.60833 7.275 6.825C7.84167 7.04167 8.35 7.35 8.8 7.75L10.5 9.3L9 10.65L7.45 9.25C7.18333 9.01667 6.88333 8.83333 6.55 8.7C6.21667 8.56667 5.86667 8.5 5.5 8.5C4.53333 8.5 3.70833 8.84167 3.025 9.525C2.34167 10.2083 2 11.0333 2 12C2 12.9667 2.34167 13.7917 3.025 14.475C3.70833 15.1583 4.53333 15.5 5.5 15.5C5.86667 15.5 6.21667 15.4333 6.55 15.3C6.88333 15.1667 7.18333 14.9833 7.45 14.75L15.2 7.75C15.65 7.35 16.1583 7.04167 16.725 6.825C17.2917 6.60833 17.8833 6.5 18.5 6.5C20.0333 6.5 21.3333 7.03333 22.4 8.1C23.4667 9.16667 24 10.4667 24 12C24 13.5333 23.4667 14.8333 22.4 15.9C21.3333 16.9667 20.0333 17.5 18.5 17.5C17.8833 17.5 17.2917 17.3917 16.725 17.175C16.1583 16.9583 15.65 16.65 15.2 16.25L13.5 14.7L15 13.35L16.55 14.75C16.8167 14.9833 17.1167 15.1667 17.45 15.3C17.7833 15.4333 18.1333 15.5 18.5 15.5C19.4667 15.5 20.2917 15.1583 20.975 14.475C21.6583 13.7917 22 12.9667 22 12C22 11.0333 21.6583 10.2083 20.975 9.525C20.2917 8.84167 19.4667 8.5 18.5 8.5C18.1333 8.5 17.7833 8.56667 17.45 8.7C17.1167 8.83333 16.8167 9.01667 16.55 9.25L8.8 16.25C8.35 16.65 7.84167 16.9583 7.275 17.175C6.70833 17.3917 6.11667 17.5 5.5 17.5Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriodicity);
export default __webpack_public_path__ + "static/media/periodicity.3ff355341113b6070f65bcc6d5601104.svg";
export { ForwardRef as ReactComponent };